// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_brand__ALhvy {
  font-size: 2rem;
}

.header_wrapper__-SPlg {
  font-size: 1.6rem;
}

.header_home__fsrAT {
  position: relative;
  color: #898686;
  text-decoration: none;
}
.header_home__fsrAT::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 0%;
  height: 3px;
  border-radius: 1px;
  background-color: #333;
  transition: 0.4s;
}
.header_home__fsrAT:hover {
  color: #111;
}
.header_home__fsrAT:hover::after {
  width: 80%;
}

.header_home_sm__4BLWo {
  color: #898686;
  text-decoration: none;
}
.header_home_sm__4BLWo:hover {
  color: #111;
}

.header_new-post__iJq9y {
  font-size: 1.6rem;
  border-radius: 8px;
}

.header_user-info__ya02c {
  display: flex;
  align-items: center;
}
.header_user-info__ya02c:hover {
  cursor: pointer;
  opacity: 0.5;
}

.header_avatar__cuvaW {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.header_username__oeGrJ {
  font-weight: bold;
  font-size: 2rem;
  white-space: nowrap;
  padding-left: 10px;
}

.header_custom-dropdown__f68rI {
  font-size: 1.6rem;
}

.header_custom-dropdown-item__0EjTp:active {
  background-color: transparent !important;
}

.header_btn-create_sm__vcdLo {
  font-size: 1.4rem;
}

.header_bar__7\\+T3z {
  font-size: 1.6rem;
  width: 5rem;
}

.header_tit_sm__skKUv {
  font-size: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/header.module.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAKA;EACI,kBAAA;EACA,cAAA;EACA,qBAAA;AAFJ;AAII;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAFR;AAKI;EACI,WAAA;AAHR;AAKQ;EACI,UAAA;AAHZ;;AAOA;EACI,cAAA;EACA,qBAAA;AAJJ;AAKI;EACI,WAAA;AAHR;;AAOA;EACI,iBAAA;EACA,kBAAA;AAJJ;;AAMA;EACI,aAAA;EACA,mBAAA;AAHJ;AAII;EACI,eAAA;EACA,YAAA;AAFR;;AAME;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;;AAME;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAHJ;;AAOE;EACE,iBAAA;AAJJ;;AAOI;EACI,wCAAA;AAJR;;AAOE;EACE,iBAAA;AAJJ;;AAME;EACE,iBAAA;EACA,WAAA;AAHJ;;AAKE;EACE,iBAAA;AAFJ","sourcesContent":["\n\n.brand{\n    font-size: 2rem;\n}\n\n.wrapper{\n    font-size: 1.6rem;\n}\n\n\n.home{\n    position: relative;\n    color: #898686;\n    text-decoration: none;\n\n    &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 10%;\n        width: 0%;\n        height: 3px;\n        border-radius: 1px;\n        background-color: #333;\n        transition: 0.4s;\n    }\n\n    &:hover {\n        color: #111;\n\n        &::after {\n            width: 80%;\n        }\n    }\n}\n.home_sm{\n    color: #898686;\n    text-decoration: none;\n    &:hover {\n        color: #111;\n    }\n\n}\n.new-post{\n    font-size: 1.6rem;\n    border-radius: 8px;\n}\n.user-info {\n    display: flex;\n    align-items: center;\n    &:hover{\n        cursor: pointer;\n        opacity: 0.5;\n    }\n  }\n  \n  .avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .username {\n    font-weight: bold;\n    font-size: 2rem;\n    white-space: nowrap;\n    padding-left: 10px;\n  }\n\n\n  .custom-dropdown{\n    font-size: 1.6rem;\n  }\n  .custom-dropdown-item{\n    &:active{\n        background-color: transparent !important;\n    }\n  }\n  .btn-create_sm{\n    font-size: 1.4rem;\n  }\n  .bar{\n    font-size: 1.6rem;\n    width: 5rem;\n  }\n  .tit_sm{\n    font-size: 2.4rem;\n  }\n  \n  \n  \n  \n  \n\n\n    \n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brand": `header_brand__ALhvy`,
	"wrapper": `header_wrapper__-SPlg`,
	"home": `header_home__fsrAT`,
	"home_sm": `header_home_sm__4BLWo`,
	"new-post": `header_new-post__iJq9y`,
	"user-info": `header_user-info__ya02c`,
	"avatar": `header_avatar__cuvaW`,
	"username": `header_username__oeGrJ`,
	"custom-dropdown": `header_custom-dropdown__f68rI`,
	"custom-dropdown-item": `header_custom-dropdown-item__0EjTp`,
	"btn-create_sm": `header_btn-create_sm__vcdLo`,
	"bar": `header_bar__7+T3z`,
	"tit_sm": `header_tit_sm__skKUv`
};
export default ___CSS_LOADER_EXPORT___;
